/******/ (() => { // webpackBootstrap
/*!*******************************!*\
  !*** ./assets/src/js/main.js ***!
  \*******************************/
document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ main.js is loaded and ready!");
});
(function () {
  function toBoolean(value) {
    return String(value) === 'true';
  }
  function initHeroSlider(scope) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) {
      console.warn('Hero slider: jQuery or Slick is not loaded.');
      return;
    }
    var $sliders = $(scope).find('.js-hero-slider');
    $sliders.each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) {
        return;
      }
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: toBoolean($slider.attr('data-arrows')),
        dots: toBoolean($slider.attr('data-dots')),
        adaptiveHeight: false,
        speed: parseInt($slider.attr('data-speed'), 10) || 600,
        autoplay: toBoolean($slider.attr('data-autoplay')),
        autoplaySpeed: parseInt($slider.attr('data-autoplay-speed'), 10) || 4000,
        fade: false
      });
    });
  }
  function destroyHeroSlider(scope) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) {
      return;
    }
    var $sliders = $(scope).find('.js-hero-slider');
    $sliders.each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    initHeroSlider(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    initHeroSlider(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroyHeroSlider(event.target);
  });
})();
/******/ })()
;
//# sourceMappingURL=main.js.map